module.exports = __webpack_public_path__ + "img/red-booth-table-6.ef3ba742.png";